import React , {useRef ,useState } from 'react';
import { uploadCJWFile } from '../../API/CJWUploadApi';
import { uploadCJWDIFile } from '../../API/CJWDIUploadApi';
import CJWUploadHistory from '../../shared/CJWUploadHistoryTable/CJWUploadHistoryTable';
import AlertManager from "../../shared/Alert/Alert";
import { COST_TYPE_OPTIONS, COST_TYPES, CJW_CLASS, CJW_CLASS_OPTIONS } from "./CJWUploadConstants";
import classes from "./CJWUpload.module.css";
import { useUploadHistory } from "../CJWUploadHistory/CJWUploadHistory.hooks";
import { Box, Button, Tooltip } from "@mui/material";
import { downloadTemplateFile } from "../../API/cjwDownloadTemplateFileApi";

// import { getCJWUploadHistory } from '../../API/CJWUploadHistoryApi';
//empty commit
const CJWUpload = () => {
    // API Calls
    // To fetch table data -> useUploadHistory method in line 19 is used to call api to fetch table data --> getCJWUploadHistory() in hooks page will inturn call the api
    // Download RAW Template -> line 12
    // File name validation - New API ( yet to write )

    const [mode, setMode] = useState("APG_ASG"); // "APG_ASG" or "DI"
    const { uploadHistory, fetchUploadHistory, loading } = useUploadHistory(mode === "DI");
    const fileInputRef = useRef();
    const [selected , setSelected] = useState("");
    const [thresholdText , setThresholdText] = useState("");
    const [cjwClass , setCjwClass] = useState("");
    const [effectiveDate, setEffectiveDate] = useState("");
    //const[uploadHistory ,fetchUploadHistory] = useState([]);   
    const handleModeChange = (event, newMode) => {
        if (newMode !== null) {
            setMode(newMode);
        }
    };

    const upload = (e) => {


        e.preventDefault();
        const form = new FormData(e.target);
        const file = form.get("file");
        const costType = form.get("costType");
        const classType = mode === "DI" ? "DI" : form.get("cjwclass");
        const target = e.target;
        const percentCost = form.get("percentCost") === "" ? 0.0 : form.get("percentCost");
        const effectiveDateValue = mode === "DI" ? form.get("effectiveDate") : null;


        if (!costType || costType === COST_TYPES.none) {
            AlertManager.error('Please select the cost type.', { contactSupport: false });
            return;
        }

        if (mode === "APG_ASG" && (!classType || classType === CJW_CLASS.none)) {
            AlertManager.error('Please select the CJW supplier-flag.', { contactSupport: false });
            return;
        }

        // if (!percentCost || isNaN(percentCost)) {
        //     AlertManager.error('Please enter a valid % cost threshold.', { contactSupport: false });
        //     return;
        // }

        if (!file) {
            AlertManager.error('Please select the file that wanted to upload.', { contactSupport: true });
            return;
        }
        if (!file.name.toLocaleLowerCase().endsWith("xlsx") && !file.name.toLocaleLowerCase().endsWith("xls")) {
            AlertManager.error('Please select file with extension .xlsx or .xls', { contactSupport: false });
            return;
        }

        const uploadFunction = mode === "DI" ? uploadCJWDIFile : uploadCJWFile;
        const uploadArgs = mode === "DI"
            ? [file, costType === COST_TYPES.approved, percentCost, effectiveDateValue]
            : [file, costType === COST_TYPES.approved, percentCost, classType];

        uploadFunction(...uploadArgs)
            .then((res) => {

                if(fileInputRef.current){
                    fileInputRef.current.value = "";
                    setSelected("");
                    setThresholdText("");
                    setEffectiveDate("");
                }


                if (res.status === 200 || res.status === 201) {
                    fetchUploadHistory();
                    AlertManager.success(`The CJW${mode === "DI" ? "-DI" : ""} has been successfully uploaded. User will receive emails on processing updates.`, { contactSupport: false });

                    target.reset();
                }
                else {

                    //  Upload filename validation error should be handled here


                    res.json().then(data => {
                        if (res.status === 400) {
                            AlertManager.error(data.error);
                        } else {
                            AlertManager.error('There were some issues while uploading the file.'

                            );
                        }
                    }).catch(() => {
                        AlertManager.error('There were some issues while processing the server response.');
                    });
                }
            })
            .catch((err) => {
                AlertManager.error('Error');
            });
    };

    return (
        <div className={classes.body}>

            <div className={classes.heading}>Upload CJW</div>
            <form className={classes.container} onSubmit={upload}>

                <Box className={classes.box}>

                    <input
                        className={classes.fileUploadInputFile}
                        name={"file"}
                        type="file"
                        accept={".xlsx, .xls"}
                        ref={fileInputRef}
                    />
                </Box>
                <Box className={classes.box}>

                    <select className={classes.fileUploadInput}
                    value={selected}
                    onChange={(e) => setSelected(e.target.value)}
                    name="costType"
                    id="cost-type"
                    >
                        {COST_TYPE_OPTIONS.map(({ value, label }) =>
                            <option key={value} value={value}>{label}</option>
                        )}
                    </select>
                </Box>

                {mode === "APG_ASG" && (
                    <Box className={classes.box}>
                        <select className={classes.fileUploadInput}
                        value={cjwClass}
                        onChange={(e) => setCjwClass(e.target.value)}
                        name="cjwclass"
                        id="cjw-class"
                        >
                            {CJW_CLASS_OPTIONS.map(({ value, label, disabled }) =>
                                <option key={value} value={value} disabled={disabled}>{label}</option>
                            )}
                        </select>
                    </Box>
                )}
                <br />

                <input
                    className={classes.fileUploadInput}
                    name={"percentCost"}
                    type="number"
                    step="0.01"
                    placeholder='Cost % Threshold'
                    value={thresholdText}
                    onChange={(e) => setThresholdText(e.target.value)}
                />

                {mode === "DI" && (
                    <input
                        className={classes.fileUploadInput}
                        name={"effectiveDate"}
                        type="date"
                        placeholder='Effective Date'
                        value={effectiveDate}
                        onChange={(e) => setEffectiveDate(e.target.value)}
                    />
                )}


                <button className={classes.uploadBtn}>upload</button>
                <Tooltip title="Download CJW Template">
                    <Button className={classes.uploadBtn}
                        onClick={() => {
                            const templateName = mode === "APG_ASG"
                                ? "NAPA - Cost Justification Worksheet_v2.xlsx"
                                : undefined;
                            downloadTemplateFile(undefined, templateName);
                        }}>
                        Download Template
                    </Button>
                </Tooltip>
            </form>

            <div className={classes.hLine}></div>

            <div className={classes.fileuploadHistory}>
                <CJWUploadHistory
                    uploadHistory={uploadHistory}
                    loading={loading}
                    isDIMode={mode === "DI"}
                    mode={mode}
                    onModeChange={handleModeChange}
                    fetchUploadHistory={fetchUploadHistory}
                />
            </div>

        </div>
    );
};

export default CJWUpload;
